import { ErrorType, LoadedType, RequestType } from 'common/actions/gongSettings';

import requestReducerFactory from './requestReducerFactory';

export default requestReducerFactory(RequestType, LoadedType, ErrorType);
